// PAT-203 — shared confirm/alert modal (rename-chat-modal shell)
import { Component, HostListener, inject } from '@angular/core';
import { ConfirmDialogService } from '../../services/confirm-dialog.service';

@Component({
  selector: 'app-pathways-confirm-dialog',
  standalone: true,
  templateUrl: './pathways-confirm-dialog.component.html',
  styleUrl: './pathways-confirm-dialog.component.scss',
})
export class PathwaysConfirmDialogComponent {
  readonly dialog = inject(ConfirmDialogService);

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (!this.dialog.active()) return;
    this.onCancel();
  }

  onBackdropClick(): void {
    this.onCancel();
  }

  onCancel(): void {
    const active = this.dialog.active();
    if (!active) return;
    if (active.mode === 'alert') {
      this.dialog.resolve(true);
      return;
    }
    this.dialog.resolve(false);
  }

  onConfirm(): void {
    this.dialog.resolve(true);
  }
}
